import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import api from '../lib/axios';
import { Database, CheckCircle, Library, Newspaper, Users, Loader2, Trash2, RefreshCw } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

// RECURSOS - Videos reales de YouTube
const RESOURCES_DATA = [
  // TÁCTICO (4 videos)
  { title: "Análisis Táctico: Sistema del Real Madrid", description: "Desglose del sistema de Ancelotti en La Liga", category: "Táctico", type: "video", url: "https://www.youtube.com/watch?v=K3nDU2dbx-U" },
  { title: "Ejercicios Técnico-Tácticos para Fútbol", description: "Ejercicios desde base hasta profesional", category: "Táctico", type: "video", url: "https://www.youtube.com/watch?v=RQg3qJ1Mvj4" },
  { title: "Pressing Alto: Cómo Ejecutarlo", description: "Conceptos de presión alta en el fútbol moderno", category: "Táctico", type: "video", url: "https://www.youtube.com/watch?v=lijkuoFiZE4" },
  { title: "Transiciones Ofensivas Efectivas", description: "Claves para contragolpes rápidos", category: "Táctico", type: "video", url: "https://www.youtube.com/watch?v=J0d4AwqM5_I" },
  
  // TÉCNICO (5 videos)
  { title: "Control Orientado, Conducción y Pase", description: "Entrenamiento técnico individual en casa", category: "Técnico", type: "video", url: "https://www.youtube.com/watch?v=YLtlPQl8Gms" },
  { title: "Ejercicios de Control y Pase con Busquets", description: "Sergio Busquets enseña precisión en pases", category: "Técnico", type: "video", url: "https://www.youtube.com/watch?v=eM_VgIoDJwU" },
  { title: "TOP 25 Ejercicios de Técnica Individual", description: "Rutinas completas de regates y control", category: "Técnico", type: "video", url: "https://www.youtube.com/watch?v=b5VRvhOTbCc" },
  { title: "Regate y Control Orientado", description: "Fintas y técnica para desbordar rivales", category: "Técnico", type: "video", url: "https://www.youtube.com/watch?v=JUMlu7_QJlM" },
  { title: "Tutorial: Regates, Pases y Controles", description: "Guía completa de técnica individual", category: "Técnico", type: "video", url: "https://www.youtube.com/watch?v=GjcpQ4Q21DI" },
  
  // MENTAL (5 videos)
  { title: "La MEJOR MENTALIDAD para FUTBOLISTAS", description: "Desbloquea tu mente: resiliencia y concentración", category: "Mental", type: "video", url: "https://www.youtube.com/watch?v=TOwgmO3pGjw" },
  { title: "Psicólogo Deportivo: El Triángulo Mágico", description: "Erik Llorca explica las 5 áreas de vida para progresar", category: "Mental", type: "video", url: "https://www.youtube.com/watch?v=oItHhkxHjvo" },
  { title: "La Psicología en el Fútbol - Salud Mental", description: "Presión mediática y necesidad de psicólogos", category: "Mental", type: "video", url: "https://www.youtube.com/watch?v=fd_BtqZ6NrE" },
  { title: "Psicología de la Selección Española", description: "Técnicas de concentración bajo estrés", category: "Mental", type: "video", url: "https://www.youtube.com/watch?v=qgn8r8zSlPY" },
  { title: "Control Emocional para Futbolistas", description: "Gestión de frustración y mentalidad profesional", category: "Mental", type: "video", url: "https://www.youtube.com/watch?v=nquSY5sIQUg" },
  
  // FÍSICO (3 videos)
  { title: "Preparación Física en Gimnasio", description: "Sesión completa: agilidad, saltos y fuerza", category: "Físico", type: "video", url: "https://www.youtube.com/watch?v=b_ZCNCXd7mA" },
  { title: "Entrenamiento de Control de Balón", description: "6 ejercicios básicos: zig-zag, bicicleta, escaleras", category: "Físico", type: "video", url: "https://www.youtube.com/watch?v=fV1LnM-gWoI" },
  { title: "Rutina de Calentamiento Profesional", description: "Calentamiento completo pre-partido", category: "Físico", type: "video", url: "https://www.youtube.com/watch?v=mbiBHqQYDHw" },
  
  // NUTRICIÓN (5 videos)
  { title: "Nutrición en Futbolistas: Errores Comunes", description: "Podcast MIOBIO sobre dietas y suplementos", category: "Nutrición", type: "video", url: "https://www.youtube.com/watch?v=yRVCS_SpQ5w" },
  { title: "Nutrición Deportiva de Élite", description: "Planificación personalizada y recuperación", category: "Nutrición", type: "video", url: "https://www.youtube.com/watch?v=CEVXawuw3jk" },
  { title: "10 Hábitos de Futbolistas para Rendir Más", description: "Johnny Ondina, exnutricionista Valencia CF", category: "Nutrición", type: "video", url: "https://www.youtube.com/watch?v=mV_YydJw7rE" },
  { title: "Nutrición de un Futbolista Profesional", description: "Andrea Orlandi: alimentación equilibrada real", category: "Nutrición", type: "video", url: "https://www.youtube.com/watch?v=qpxHMlYfygY" },
  { title: "Dieta del Real Valladolid", description: "Cómo preparan las comidas los pros", category: "Nutrición", type: "video", url: "https://www.youtube.com/watch?v=sI8ZrtnvyDM" },
  
  // CARRERA (2 videos)
  { title: "Marca Personal: Marcos Llorente", description: "Entrevista exclusiva sobre imagen pública", category: "Carrera", type: "video", url: "https://www.youtube.com/watch?v=HG95uuoVbUY" },
  { title: "Gestión de Redes Sociales para Futbolistas", description: "Cómo construir tu marca personal", category: "Carrera", type: "video", url: "https://www.youtube.com/watch?v=GqXfTKOrwEY" },
  
  // PORTEROS - PDFs exclusivos de Ikons (5 documentos)
  { title: "Ikons Porteros Elite", description: "Programa completo de desarrollo para porteros de élite", category: "goalkeeper", type: "pdf", url: "https://customer-assets.emergentagent.com/job_player-connect-ikons/artifacts/6bnky1he_Ikons_Porteros_Elite.pdf", author: "Ikons Agency" },
  { title: "Plan de Entrenamiento Mental - Portero", description: "Metodología de preparación mental específica para porteros", category: "goalkeeper", type: "pdf", url: "https://customer-assets.emergentagent.com/job_player-connect-ikons/artifacts/k4ycqk6m_Plan_Entrenamiento_Mental_Portero_Ikons.pdf", author: "Ikons Agency" },
  { title: "Manual del Portero Ikons", description: "Guía completa de fundamentos y técnicas para porteros", category: "goalkeeper", type: "pdf", url: "https://customer-assets.emergentagent.com/job_player-connect-ikons/artifacts/dr1qagr5_Manual_Portero_Ikons.pdf", author: "Ikons Agency" },
  { title: "Post Partido - Porteros Ikons", description: "Protocolo de análisis post-partido para porteros", category: "goalkeeper", type: "pdf", url: "https://customer-assets.emergentagent.com/job_player-connect-ikons/artifacts/or5rka48_Post_Partido_Porteros_Ikons.pdf", author: "Ikons Agency" },
  { title: "Plan de Partido - Portero Ikons", description: "Preparación estratégica pre-partido para porteros", category: "goalkeeper", type: "pdf", url: "https://customer-assets.emergentagent.com/job_player-connect-ikons/artifacts/591zffcb_Plan_Partido_Portero_Ikons.pdf", author: "Ikons Agency" },
];

// NOTICIAS
const NEWS_DATA = [
  {
    title: "IKONS PLAYER SYSTEM - Bienvenidos a una nueva forma de desarrollarse en el fútbol",
    content: `Ikons Agency da un paso adelante en el desarrollo del jugador con el lanzamiento oficial del Ikons Player System, una metodología estructurada diseñada para optimizar el rendimiento de sus futbolistas.

Este sistema nace de una necesidad clara: transformar el talento en rendimiento consistente a través de un proceso organizado, medible y consciente.

⚫ Una nueva forma de trabajar

En el fútbol actual, muchos jugadores entrenan, compiten y repiten, pero no siempre mejoran de forma real. El Ikons Player System rompe con esa dinámica.

A partir de ahora, cada jugador de la agencia trabajará bajo una estructura clara basada en cuatro pilares:
• Preparación previa a la competición
• Ejecución consciente en partido
• Análisis post-partido
• Planificación adaptativa semanal

Todo ello acompañado de un sistema de seguimiento continuo que permite convertir cada experiencia en aprendizaje.

🧠 Más allá del talento

El objetivo del sistema no es solo mejorar el rendimiento puntual, sino desarrollar jugadores capaces de:
• Entender su propio juego
• Tomar mejores decisiones
• Sostener su nivel en el tiempo
• Competir con un estándar alto cada día

Porque en Ikons entendemos que el talento abre puertas, pero es el proceso el que permite mantenerse.

🔁 Un sistema vivo

El Ikons Player System no es una herramienta aislada. Es un sistema dinámico que conecta cada fase del rendimiento del jugador, permitiendo:
• Detectar patrones
• Ajustar comportamientos
• Acelerar la mejora

Cada partido deja de ser un evento aislado y pasa a formar parte de un proceso continuo de evolución.

🚀 Compromiso y exigencia

Formar parte de este sistema implica asumir una responsabilidad. No se trata solo de jugar, sino de trabajar con intención, analizar con honestidad y mejorar de forma constante.

En Ikons no buscamos solo jugadores con talento, sino jugadores comprometidos con su desarrollo.

🎯 Bienvenidos al siguiente nivel

Con el lanzamiento del Ikons Player System, la agencia refuerza su compromiso con una visión clara:

👉 Desarrollar jugadores completos, conscientes y preparados para competir al máximo nivel.

Bienvenidos a Ikons.
Bienvenidos a una nueva forma de entender el fútbol.`
  },
  {
    title: "Ikons refuerza su compromiso con el desarrollo individual del jugador",
    content: `Ikons Agency continúa consolidando su modelo de trabajo centrado en el crecimiento integral del futbolista, incorporando nuevas herramientas y procesos orientados a potenciar el rendimiento individual de cada jugador.

🧠 Desarrollo más allá del campo

En un entorno donde el rendimiento ya no depende únicamente de lo físico y lo técnico, Ikons apuesta por un enfoque más completo.

El objetivo es claro:
👉 Ayudar al jugador a entender su juego
👉 Mejorar su toma de decisiones
👉 Desarrollar una mentalidad competitiva sólida

⚙️ Herramientas para el día a día

Durante los últimos meses, la agencia ha trabajado en la implementación de recursos prácticos que permiten al jugador tener un mayor control sobre su evolución.

Entre ellos:
• Planificación personal de partidos
• Análisis post-competición
• Seguimiento semanal del rendimiento
• Control del estándar diario

Estas herramientas buscan transformar el día a día del jugador, haciéndolo más consciente, estructurado y orientado a la mejora.

🔁 Un proceso continuo

Desde Ikons destacan que el desarrollo no se basa en momentos puntuales, sino en la consistencia.

Cada entrenamiento, cada partido y cada semana forman parte de un proceso conectado que permite al jugador avanzar de forma progresiva.

🚀 Una visión clara

Con este enfoque, Ikons reafirma su compromiso de acompañar al futbolista no solo en su carrera profesional, sino en su evolución como competidor.

⚫ El jugador en el centro

En Ikons, cada jugador es único.

Por eso, el trabajo se adapta a sus necesidades, su contexto y su momento, buscando siempre maximizar su potencial.

Porque el verdadero crecimiento no es casualidad.
Es consecuencia de un proceso.`
  },
  {
    title: "La importancia de la toma de decisiones en el fútbol moderno",
    content: `Ikons Agency pone el foco en uno de los aspectos más determinantes del rendimiento en el fútbol actual: la toma de decisiones.

En un juego cada vez más rápido y exigente, la capacidad de decidir bien en pocos segundos se ha convertido en un factor diferencial entre jugadores.

🧠 Decidir mejor, competir mejor

Cada acción dentro del campo implica una decisión:
• Pasar o conducir
• Jugar seguro o arriesgar
• Presionar o esperar
• Acelerar o pausar

Aunque muchas veces pasan desapercibidas, estas decisiones determinan el impacto real de un jugador en el juego.

⚡ No es solo técnica

Tener buena técnica ya no es suficiente.

El fútbol moderno exige:
• Leer el juego
• Anticipar situaciones
• Elegir la mejor opción en cada momento

Un jugador puede ejecutar bien… pero si decide mal, pierde valor.

🔍 La diferencia está en los detalles

En muchos casos, la diferencia entre dos jugadores no está en su capacidad física o técnica, sino en:
👉 La velocidad con la que entienden el juego
👉 La calidad de sus decisiones

🔁 Un aspecto entrenable

La toma de decisiones no es algo fijo.

Se puede mejorar a través de:
• Mayor comprensión del juego
• Análisis de situaciones reales
• Experiencia consciente
• Trabajo específico en entrenamiento

🚀 Un enfoque clave en Ikons

Desde Ikons Agency se trabaja este aspecto como una parte fundamental del desarrollo del jugador, ayudándole a:
• Entender por qué decide como decide
• Detectar patrones
• Mejorar su claridad dentro del campo

⚫ Pensar mejor para jugar mejor

En un deporte donde cada segundo cuenta, decidir bien marca la diferencia.

Porque no gana el que más corre.
Gana el que mejor entiende el juego.`
  }
];

function AdminSetup() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [results, setResults] = useState(null);
  const [currentCounts, setCurrentCounts] = useState({ resources: 0, news: 0 });
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // Check auth and role - with more robust handling
  useEffect(() => {
    // Wait for auth to finish loading
    if (authLoading) return;
    
    // Check if user exists and has valid token
    const token = localStorage.getItem('jwt_token');
    
    if (!user && !token) {
      toast.error('Debes iniciar sesión como agente');
      navigate('/login/staff');
    } else if (user && user.role !== 'agent') {
      toast.error('Solo agentes pueden acceder a esta página');
      navigate('/dashboard');
    }
    // If we have token but user is null, the AuthContext is still loading - wait
  }, [user, authLoading, navigate]);

  // Fetch current counts
  const fetchCurrentCounts = async () => {
    try {
      console.log('Fetching counts with token:', !!localStorage.getItem('jwt_token'));
      const [resRes, newsRes] = await Promise.all([
        api.get('/resources'),
        api.get('/news')
      ]);
      setCurrentCounts({
        resources: resRes.data?.length || 0,
        news: newsRes.data?.length || 0
      });
      console.log('Counts fetched:', resRes.data?.length, newsRes.data?.length);
    } catch (err) {
      console.error('Error fetching counts:', err);
      // If auth error, might need to re-login
      if (err.response?.status === 401) {
        toast.error('Sesión expirada. Por favor, inicia sesión de nuevo.');
        navigate('/login/staff');
      }
    }
  };

  useEffect(() => {
    if (user) {
      fetchCurrentCounts();
    }
  }, [user]);

  const handleDeleteAll = async () => {
    if (!window.confirm('¿Estás seguro de borrar TODOS los recursos y noticias? Esta acción no se puede deshacer.')) {
      return;
    }
    
    setLoading(true);
    setStatus('Borrando recursos...');
    setResults(null);
    
    let deletedResources = 0;
    let deletedNews = 0;
    
    try {
      // Delete resources
      const resourcesRes = await api.get('/resources');
      const resources = resourcesRes.data || [];
      
      for (let i = 0; i < resources.length; i++) {
        try {
          await api.delete(`/resources/${resources[i].resource_id}`);
          deletedResources++;
          setStatus(`Borrando recursos... ${i + 1}/${resources.length}`);
        } catch (err) {
          console.error('Error deleting resource:', err.response?.data || err);
        }
      }
      
      // Delete news
      setStatus('Borrando noticias...');
      const newsRes = await api.get('/news');
      const news = newsRes.data || [];
      
      for (let i = 0; i < news.length; i++) {
        try {
          await api.delete(`/news/${news[i].news_id}`);
          deletedNews++;
          setStatus(`Borrando noticias... ${i + 1}/${news.length}`);
        } catch (err) {
          console.error('Error deleting news:', err.response?.data || err);
        }
      }
      
      setResults({ deleted: { resources: deletedResources, news: deletedNews } });
      toast.success(`Borrados: ${deletedResources} recursos, ${deletedNews} noticias`);
      await fetchCurrentCounts();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al borrar datos: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
      setStatus('');
    }
  };

  const handleLoadAll = async () => {
    setLoading(true);
    setStatus('Cargando recursos...');
    setResults(null);
    
    let addedResources = 0;
    let addedNews = 0;
    let errors = 0;
    const errorDetails = [];
    
    try {
      // Load resources
      for (let i = 0; i < RESOURCES_DATA.length; i++) {
        try {
          await api.post('/resources', RESOURCES_DATA[i]);
          addedResources++;
        } catch (err) {
          errors++;
          errorDetails.push(`Recurso ${i + 1}: ${err.response?.data?.detail || err.message}`);
        }
        setStatus(`Cargando recursos... ${i + 1}/${RESOURCES_DATA.length}`);
      }
      
      // Load news
      setStatus('Cargando noticias...');
      for (let i = 0; i < NEWS_DATA.length; i++) {
        try {
          await api.post('/news', NEWS_DATA[i]);
          addedNews++;
        } catch (err) {
          errors++;
          errorDetails.push(`Noticia ${i + 1}: ${err.response?.data?.detail || err.message}`);
        }
        setStatus(`Cargando noticias... ${i + 1}/${NEWS_DATA.length}`);
      }
      
      setResults({ added: { resources: addedResources, news: addedNews, errors, errorDetails } });
      
      if (addedResources > 0 || addedNews > 0) {
        toast.success(`Cargados: ${addedResources} recursos, ${addedNews} noticias`);
      }
      if (errors > 0) {
        console.log('Errores:', errorDetails);
        toast.warning(`${errors} elementos no se pudieron cargar`);
      }
      await fetchCurrentCounts();
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al cargar datos: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
      setStatus('');
    }
  };

  const handleUpgradeAccount = async () => {
    setLoading(true);
    try {
      await api.post('/auth/upgrade-to-agent', {
        email: 'merinovidangossy@gmail.com'
      });
      toast.success('¡Cuenta actualizada a Agente!');
      setTimeout(() => window.location.href = '/dashboard', 2000);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error');
    } finally {
      setLoading(false);
    }
  };

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#D4AF37]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 py-8">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#4F4F4F]">Configuración Inicial</h1>
          <p className="text-muted-foreground mt-2">Herramientas de administrador para Ikons</p>
        </div>

        {/* Manage Data Card */}
        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Database className="h-6 w-6 text-blue-600" />
              </div>
              <div className="flex-1">
                <CardTitle>Gestionar Datos</CardTitle>
                <CardDescription>Recursos y Noticias de la plataforma</CardDescription>
              </div>
              <Button 
                variant="outline" 
                size="sm"
                onClick={fetchCurrentCounts}
                disabled={loading}
              >
                <RefreshCw className="h-4 w-4" />
              </Button>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            {/* Current DB Status */}
            <div className="p-3 bg-slate-100 rounded-lg">
              <p className="text-xs font-medium text-slate-600 mb-2">Estado actual en BD:</p>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-2">
                  <Library className="h-5 w-5 text-purple-500" />
                  <span>{currentCounts.resources} recursos</span>
                </div>
                <div className="flex items-center gap-2">
                  <Newspaper className="h-5 w-5 text-green-500" />
                  <span>{currentCounts.news} noticias</span>
                </div>
              </div>
            </div>
            
            {/* Expected Data */}
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div className="flex items-center gap-2 p-3 bg-purple-50 rounded-lg">
                <Library className="h-5 w-5 text-purple-500" />
                <span>Cargar: 24 Videos</span>
              </div>
              <div className="flex items-center gap-2 p-3 bg-green-50 rounded-lg">
                <Newspaper className="h-5 w-5 text-green-500" />
                <span>Cargar: 3 Noticias</span>
              </div>
            </div>
            
            <div className="text-xs text-muted-foreground p-3 bg-gray-50 rounded-lg">
              <p className="font-medium mb-1">Categorías de Videos:</p>
              <p>Táctico (4) • Técnico (5) • Mental (5) • Físico (3) • Nutrición (5) • Carrera (2)</p>
            </div>
            
            {loading && status && (
              <div className="flex items-center gap-2 text-sm text-blue-600 p-3 bg-blue-50 rounded-lg">
                <Loader2 className="h-4 w-4 animate-spin" />
                <span>{status}</span>
              </div>
            )}
            
            {results?.deleted && (
              <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg text-sm">
                <p className="font-medium text-orange-700">Borrado completado:</p>
                <p className="text-orange-600">• {results.deleted.resources} recursos</p>
                <p className="text-orange-600">• {results.deleted.news} noticias</p>
              </div>
            )}
            
            {results?.added && (
              <div className="p-3 bg-green-50 border border-green-200 rounded-lg text-sm">
                <p className="font-medium text-green-700">Carga completada:</p>
                <p className="text-green-600">• {results.added.resources} recursos</p>
                <p className="text-green-600">• {results.added.news} noticias</p>
                {results.added.errors > 0 && (
                  <p className="text-orange-600">• {results.added.errors} ya existían</p>
                )}
              </div>
            )}
            
            <div className="flex gap-2">
              <Button 
                variant="destructive"
                className="flex-1" 
                onClick={handleDeleteAll}
                disabled={loading}
              >
                <Trash2 className="h-4 w-4 mr-2" />
                {loading ? 'Procesando...' : '1. Borrar Todo'}
              </Button>
              <Button 
                className="flex-1 bg-green-600 hover:bg-green-700" 
                onClick={handleLoadAll}
                disabled={loading}
              >
                <Database className="h-4 w-4 mr-2" />
                {loading ? 'Procesando...' : '2. Cargar Todo'}
              </Button>
            </div>
            
            <p className="text-xs text-center text-muted-foreground">
              Primero borra, luego carga para evitar duplicados
            </p>
          </CardContent>
        </Card>

        {/* Upgrade Account Card */}
        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-amber-100 rounded-lg">
                <Users className="h-6 w-6 text-amber-600" />
              </div>
              <div>
                <CardTitle>Actualizar a Agente</CardTitle>
                <CardDescription>Convierte tu cuenta a rol de Agente</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <Button 
              className="w-full bg-gradient-to-r from-[#D4AF37] to-[#A67C00]" 
              onClick={handleUpgradeAccount}
              disabled={loading}
            >
              {loading ? 'Actualizando...' : 'Actualizar a Agente'}
            </Button>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-muted-foreground">
          Esta página usa tu sesión de agente autenticada
        </p>
      </div>
    </div>
  );
}

export default AdminSetup;
